import { useMutation, useQuery } from '@tanstack/react-query';
import { keyBy } from 'lodash';
import { HolidayCalendarAPI } from 'api/holiday-calendar';
import { oneDay } from './constants';
export const HOLIDAY_CALENDAR_KEY = [
    'holiday_calendar'
];
export const useHolidayCalendars = (options = {})=>{
    return useQuery(HOLIDAY_CALENDAR_KEY, ()=>HolidayCalendarAPI.getHolidayCalendars().then((holidayCalendars)=>keyBy(holidayCalendars, 'holidayCalendarId')), {
        staleTime: oneDay,
        ...options
    });
};
export const useHolidayCalendarDeleteMutation = (options = {})=>useMutation(({ calendarId })=>HolidayCalendarAPI.deleteHolidayCalendar(calendarId), options);
export const useHolidayCalendarUpdateMutation = (options = {})=>useMutation((holidayCalendar)=>HolidayCalendarAPI.editHolidayCalendar(holidayCalendar), options);
export const useHolidayCalendarCreateMutation = (options = {})=>useMutation((holidayCalendar)=>HolidayCalendarAPI.createHolidayCalendar(holidayCalendar), options);
